export default __webpack_public_path__ + "locales/ja-JP/Files.json?hash=ddd20bb475793d8ce0ff6f0fa231183b";